import React, { useState, useEffect } from "react";
import { DatePicker, Radio, Button } from "antd";
import { RoundedSearch } from "../../../RoundedSearch";
import { DownloadButton } from "../../../DownloadButton";
import styles from "./style.module.scss";

const { RangePicker } = DatePicker;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

const GRANULARITY_OPTIONS = [
  { value: "daily", label: "D" },
  { value: "weekly", label: "W" },
  { value: "monthly", label: "M" },
];

const DownloadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" x2="12" y1="15" y2="3" />
  </svg>
);

const Header = ({
  header,
  pageTitle,
  showSearch = false,
  searchValue = "",
  onSearchChange,
  onSearch,
  searchPlaceholder = "Search...",
  showDateRange = false,
  showGranularity = true,
  dateRangeValue,
  onDateRangeChange,
  disabledDate,
  dateFormat = "ll",
  granularity = "daily",
  onGranularityChange,
  granularityDisabled = false,
  showAction = false,
  onAction,
  actionLabel = "Add",
  actionIcon = "fa fa-plus",
  showDownload = false,
  onDownload,
  downloadLoading = false,
  downloadLabel = "Download",
  downloadIcon = "fa fa-download",
  downloadIconOnly = false,
  searchSuffix,
  headerExtra,
  searchDisabled = false,
}) => {
  const [localGranularity, setLocalGranularity] = useState(granularity);
  const [localSearchValue, setLocalSearchValue] = useState(searchValue);

  useEffect(() => {
    setLocalGranularity(granularity);
  }, [granularity]);

  useEffect(() => {
    setLocalSearchValue(searchValue);
  }, [searchValue]);

  return (
    <div className={styles.header}>
      <div className={styles.left}>
        <h1 className={styles.h1}>{header}</h1>
        <p className={styles.h1Sub}>{pageTitle}</p>
      </div>

      {showSearch && (
        <div className={styles.center}>
          <RoundedSearch
            placeholder={searchPlaceholder}
            value={localSearchValue}
            onSearch={(val) => (onSearch || onSearchChange) && (onSearch || onSearchChange)(val)}
            allowClear
            disabled={searchDisabled}
            onChange={(e) => {
              setLocalSearchValue(e.target.value);
              onSearchChange && onSearchChange(e.target.value);
              if (e.target.value === "") onSearch && onSearch("");
            }}
            suffix={searchSuffix}
          />
        </div>
      )}

      {(showDateRange || showAction || showDownload || headerExtra) && (
        <div className={styles.rightGroup}>
          {headerExtra && headerExtra}
          {showDateRange && (
            <div className={styles.right}>
              {showGranularity && (
                <div className={`granularity-radio${granularityDisabled ? ` ${styles.granularityDisabled}` : ""}`}>
                  <RadioGroup
                    className={`month-selecter${granularityDisabled ? ` ${styles.granularityDisabledSelector}` : ""}`}
                    value={localGranularity}
                    size="large"
                    onChange={(e) => {
                      if (granularityDisabled) return;
                      setLocalGranularity(e.target.value);
                      onGranularityChange && onGranularityChange(e.target.value);
                    }}
                  >
                    {GRANULARITY_OPTIONS.map((opt) => (
                      <RadioButton key={opt.value} value={opt.value}>
                        {opt.label}
                      </RadioButton>
                    ))}
                  </RadioGroup>
                </div>
              )}

              <RangePicker
                className="granular-calender"
                value={dateRangeValue}
                onChange={onDateRangeChange}
                format={dateFormat}
                disabledDate={disabledDate}
                placeholder={["Select", "Date"]}
                allowClear={false}
              />
            </div>
          )}

          {showAction && (
            <div className={styles.downloadWrap}>
              <Button
                className={`${styles.downloadBtn} ${styles.actionWithIcon}`}
                onClick={onAction}
              >
                <i className={`${actionIcon} ${styles.actionIcon}`}></i>
                {actionLabel}
              </Button>
            </div>
          )}

          {showDownload && (
            <div className={styles.downloadWrap}>
              {downloadIconOnly ? (
                <DownloadButton onClick={onDownload} loading={downloadLoading} />
              ) : (
                <Button
                  className={styles.downloadBtn}
                  loading={downloadLoading}
                  onClick={onDownload}
                >
                  {!downloadLoading && <i style={{ marginTop: '5px' }} className={downloadIcon}></i>}
                  {downloadLabel}
                </Button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Header;
